import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../api/axios";
import ACMLogo from "../PIC/Logo/DIET_ACM_Logo.png";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("+91-XXXXXXXXXX");
  const MAPS_URL = "https://maps.app.goo.gl/gk69jC22ckPV6aTFA";
  const DEFAULT_EMAIL = "dietacmchapter@diet.edu.in";

  useEffect(() => {
    axios
      .get("/contactinfo")
      .then((res) => {
        if (res.data?.phone) {
          setPhone(res.data.phone);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch phone:", err);
        setPhone("+91-XXXXXXXXXX");
      });
  }, []);

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Top Grid */}
        <div className="footer-main-grid">
          {/* Column 1: Brand & Bio */}
          <div className="footer-brand-col">
            <div className="footer-brand">
              <img src={ACMLogo} alt="DIET ACM Logo" className="footer-logo" />
              <div className="footer-brand-text">
                <span className="brand-title">DIET ACM</span>
                <span className="brand-tag">Student Chapter</span>
              </div>
            </div>
            <p className="footer-bio">
              Fostering a vibrant community of passionate learners, developers,
              and researchers at Dadi Institute of Engineering &amp; Technology.
            </p>
            {/* Social Icons */}
            <div className="footer-socials">
              <a
                href="https://www.linkedin.com/in/diet-acm-chapter-846b55328/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="social-btn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://www.instagram.com/diet_acm"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-btn"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100090846908967"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-btn"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Quick Navigation</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="/">Home Overview</Link>
              </li>
              <li>
                <Link to="/blogs">Technical Blogs</Link>
              </li>
              <li>
                <Link to="/events">Our Events</Link>
              </li>
              <li>
                <Link to="/calendar">Event Calendar</Link>
              </li>
              <li>
                <Link to="/ourteam">Leadership Team</Link>
              </li>
              <li>
                <Link to="/gallery">Photo Gallery</Link>
              </li>
              <li>
                <Link to="/benefits">Membership Benefits</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact & Location */}
          <div className="footer-contact-col">
            <h4 className="footer-col-title">Contact &amp; Location</h4>
            <div className="footer-contact-list">
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item"
              >
                <div className="contact-icon-box">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div>
                  <span className="contact-label">Location</span>
                  <p className="contact-val">
                    Dadi Institute of Engg. &amp; Tech, Anakapalle, AP
                  </p>
                </div>
              </a>

              <div className="footer-contact-item">
                <div className="contact-icon-box">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div>
                  <span className="contact-label">Call Support</span>
                  <p className="contact-val">{phone}</p>
                </div>
              </div>

              <a
                href={`mailto:${DEFAULT_EMAIL}`}
                className="footer-contact-item"
              >
                <div className="contact-icon-box">
                  <i className="fas fa-envelope"></i>
                </div>
                <div>
                  <span className="contact-label">Official Email</span>
                  <p className="contact-val">{DEFAULT_EMAIL}</p>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <p className="footer-copy">
            © {new Date().getFullYear()} DIET ACM Student Chapter. All rights
            reserved.
          </p>

          <button
            className="developer-badge-btn"
            onClick={() => navigate("/developer")}
            title="Developer Credits"
          >
            <i className="fas fa-code"></i>
            <span>Developer Info</span>
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;